<template>
  <div v-if="isLogin">
    <AccountPC v-if="isPc" />
    <div v-else class="account-page">
      <!-- 顶部 -->
      <div class="account-hero">
        <div class="account-header">
          <i class="cubeic-back" @click="goBack"></i>
          <h1 class="account-title">账户管理</h1>
          <span class="account-placeholder"></span>
        </div>
      </div>
      <div class="account-body">
        <!-- 用户信息卡片 -->
        <div class="account-user-card">
          <div class="account-avatar">
            <span class="account-avatar-text">{{ ($store.getters.name || 'U').charAt(0).toUpperCase() }}</span>
          </div>
          <div class="account-user-info">
            <span class="account-user-name">{{ $store.getters.name }}</span>
            <span class="account-user-device" v-if="currentDevice !='unknown'">
              <i class="cubeic-mobile-phone"></i>
              {{ currentDevice }}
            </span>
          </div>
        </div>

        <!-- 修改密码 -->
        <div class="account-section">
          <div class="account-section-header" @click="changePwd">
            <div class="account-section-left">
              <div class="account-section-icon">
                <i class="cubeic-lock"></i>
              </div>
              <span>修改密码</span>
            </div>
            <i :class="showPwdForm ? 'cubeic-pullup' : 'cubeic-pulldown'" class="account-arrow"></i>
          </div>
          <div v-if="showPwdForm" class="account-section-body">
            <cube-form ref="pwdForm" :model="pwdModel" :schema="pwdSchema" @submit="submitPwd"></cube-form>
          </div>
        </div>

        <!-- 退出登录 -->
        <button class="account-logout-btn" @click="logout">退出登录</button>
      </div>
    </div>
  </div>
  <div v-else>
    <LoginPC v-if="isPc" ref="loginForm" :model="model" :schema="schema" @login="handleLogin" @input="updateModel"></LoginPC>
    <LoginMobile v-else ref="loginForm" :model="model" :schema="schema" @login="handleLogin" @input="updateModel"></LoginMobile>
  </div>
</template>

<script>
import { isUserExisted, validateDeviceInfo, changePwd } from "@/api/login";
// import { get_unique_code } from "@/services/common";
import { getGlRenderer, getModels } from "@/services/device";
import LoginPC from "./LoginPC.vue";
import LoginMobile from "./LoginMobile.vue";
import AccountPC from "./AccountPC.vue";
var browser = {
  versions: function () {
    var u = navigator.userAgent;
    return {   //移动终端浏览器版本信息
      trident: u.indexOf('Trident') > -1, //IE内核
      presto: u.indexOf('Presto') > -1, //opera内核
      webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
      iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, //是否iPad
      webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
    };
  }(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
}
export default {
  components: {
    LoginPC,
    LoginMobile,
    AccountPC
  },
  data() {
    return {
      isPc: false,
      isLogin: this.$store.getters.token,
      currentDevice: "",
      showPwdForm: true,
      model: {
        // 数据模型
        username: "",
        password: ""
      },
      pwdModel: {
        o_password: "",
        n_password: "",
        n_password2: ""
      },
      pwdSchema: {
        // 表单结构模型
        fields: [
          {
            type: "input",
            modelKey: "o_password",
            label: "原始密码",
            props: {
              placeholder: "请输入原始密码",
              type: "password",
              eye: { open: false }
            },
            rules: {
              // 校验规则
              required: true
            },
            trigger: "blur",
            messages: {
              required: "原始密码为必填项"
            }
          },
          {
            type: "input",
            modelKey: "n_password",
            label: "新密码",
            props: {
              placeholder: "请输入新密码",
              type: "password",
              eye: { open: false }
            },
            rules: {
              // 校验规则
              required: true,
              min: 6,
              max: 16,
              checkopwd: val => {
                return resolve => {
                  if (val == this.pwdModel.o_password) {
                    resolve(false);
                  } else {
                    resolve(true);
                  }
                };
              }
            },
            trigger: "blur",
            messages: {
              required: "新密码为必填项",
              checkopwd: "新密码不能与原始密码相同"
            }
          },
          {
            type: "input",
            modelKey: "n_password2",
            label: "校验",
            props: {
              placeholder: "请再次输入新密码",
              type: "password",
              eye: { open: false }
            },
            rules: {
              // 校验规则
              required: true,
              min: 6,
              max: 16,
              pwdcheck: val => {
                return resolve => {
                  if (val == this.pwdModel.n_password) {
                    resolve(true);
                  } else {
                    resolve(false);
                  }
                };
              }
            },
            trigger: "blur",
            messages: {
              required: "请再次输入新密码",
              pwdcheck: "两次密码输入不一致"
            }
          },
          {
            type: "submit",
            label: "确认修改"
          }
        ]
      },
      schema: {
        // 表单结构模型
        fields: [
          {
            type: "input",
            modelKey: "username",
            label: "用户名",
            props: {
              placeholder: "请输入用户名"
            },
            rules: {
              // 校验规则
              required: true,
              min: 3,
              max: 11,
              usercheck: val => {
                return async resolve => {
                  if (val) {
                    const res = await isUserExisted(val);
                    const { message } = res.data;
                    resolve(message);
                  } else {
                    resolve(false);
                  }
                };
              }
            },
            trigger: "blur",
            messages: {
              required: "用户名为必填项",
              usercheck: "用户名不存在"
            }
          },
          {
            type: "input",
            modelKey: "password",
            label: "密码",
            props: {
              placeholder: "请输入密码",
              type: "password",
              eye: { open: false }
            },
            rules: {
              // 校验规则
              required: true
            },
            trigger: "blur",
            messages: {
              required: "密码为必填项"
            }
          }
        ]
      }
    };
  },
  methods: {
    changePwd() {
      this.showPwdForm = !this.showPwdForm;
    },
    goBack() {
      this.$router.go(-1);
    },
    async submitPwd(e, { o_password, n_password }) {
      e.preventDefault();
      try {
        const res = await changePwd(
            this.$store.getters.name,
            o_password,
            n_password
        );
        if (res.status === 200) {
          this.$createToast({
            txt: res.data.message,
            type: "success",
            time: 1000
          }).show();
          setTimeout(() => {
            this.logout();
          }, 1000);
        }
      } catch (err) {
        this.$createToast({
          txt: err,
          type: "error",
          time: 1500
        }).show();
      }
    },
    showBtn(content, isReset = false) {
      this.$createDialog({
        type: "confirm",
        icon: "cubeic-alert",
        title: "绑定设备",
        content: content,
        confirmBtn: {
          text: "是",
          active: true,
          disabled: false,
          href: "javascript:;"
        },
        cancelBtn: {
          text: "否",
          active: false,
          disabled: false,
          href: "javascript:;"
        },
        onConfirm: () => {
          this.startLogin(isReset);
        },
        onCancel: () => { }
      }).show();
    },
    startLogin(isReset = false) {
      let device = getGlRenderer();
      const toast = this.$createToast({
        txt: "努力登录中...",
        type: "loading",
        mask: true,
        time: 0
      });
      toast.show();
      this.$store
          .dispatch("LoginByUsername", {
            username: this.model.username,
            password: this.model.password,
            device,
            isReset
          })
          .then(value => {
            if (this.isPc && !value.enablePc) {
              this.$store.dispatch("FedLogOut")
              this.$createToast({
                txt: '您没有PC登录权限，请联系管理员',
                type: "error"
              });
            }else if (value) {
              this.$createToast({
                txt: value.message || "登录成功",
                type: "correct"
              });
              setTimeout(() => {
                toast.hide();
                //重定向
                const redirect = this.$route.query.redirect || "/";
                this.$router.push(redirect);
              }, 500);
            } else {
              throw "登录异常";
            }
          })
          .catch(err => {
            this.$createToast({
              txt: err,
              type: "error"
            });
            setTimeout(() => {
              toast.hide();
            }, 2000);
          });
    },
    updateModel(newModel) {
      this.model.username = newModel.username || '';
      this.model.password = newModel.password || '';
    },
    async handleLogin(e) {
      if (e) {
        e.preventDefault();
      }
      try {
        let result = await this.$refs.loginForm.validate();
        if (result) {
          const res = await validateDeviceInfo(
              this.model.username,
              this.model.password
          );
          if (res.status === 200) {
            const { device, times } = res.data.message;
            let curretDeviceInfo = getGlRenderer();
            if (!device) {
              this.showBtn("当前您未绑定设备,是否绑定当前设备?", false);
            } else {
              if (curretDeviceInfo == device) {
                this.startLogin();
              } else {
                // 最多重置2次设备
                let leftTimes = 3 - times;
                if (leftTimes > 0) {
                  this.showBtn(
                      `当前设备与您绑定的设备不一致,是否重置您绑定设备?<br>(剩余可重置次数：${leftTimes})`,
                      true
                  );
                } else {
                  throw "登录失败<br>(当前设备与绑定设备不符)";
                }
              }
            }
          } else {
            throw "登录异常";
          }
        } else {
          throw "登录失败";
        }
      } catch (err) {
        this.$createToast({
          txt: err,
          type: "error",
          time: 1500
        }).show();
      }
    },
    logout() {
      this.$store.dispatch("FedLogOut").then(() => {
        this.$router.push("/redirect/login");
      });
    },
    IsPCVisted() {
      if (window.innerWidth < 768) return false;
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod", "Mobi", "Mobile"];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) !== -1) {
          return false;
        }
      }
      return true;
    },
    isQQ() {
      if (browser.versions.mobile) {//判断是否是移动设备打开。browser代码在下面
        var ua = navigator.userAgent.toLowerCase();//获取判断用的对象
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          //在微信中打开
          return true
        }
        if (ua.match(/WeiBo/i) == "weibo") {
          //在新浪微博客户端打开
          return true
        }
        if (ua.match(/QQ/i) == "qq") {
          //在QQ空间打开
          return true
        }
        return false
        // if (browser.versions.ios) {
        //   //是否在IOS浏览器打开

        // }
        // if (browser.versions.android) {
        //   //是否在安卓浏览器打开

        // }
      } else {
        //否则就是PC浏览器打开
        return true
      }
    }  },
  created() {
    this.isPc = this.IsPCVisted();
    this.currentDevice = getModels().join(" or ");
  }
};
</script>

<style>
@import "../assets/stytels/login.css";

.account-page {
  background: #f4f6fb;
  min-height: 100vh;
  padding-bottom: 30px;
}

/* ---- 顶部 ---- */
.account-hero {
  background: linear-gradient(135deg, #1a1a2e, #0f3460);
  padding: 16px;
  position: relative;
}

.account-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.account-header .cubeic-back {
  font-size: 22px;
  color: rgba(255, 255, 255, 0.85);
  padding: 4px 8px 4px 0;
}

.account-title {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin: 0;
  letter-spacing: 0.5px;
}

.account-placeholder {
  width: 30px;
}

/* ---- 内容区 ---- */
.account-body {
  padding: 0 16px;
}

/* 用户信息卡片 */
.account-user-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 18px;
  padding: 28px 22px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  gap: 18px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 6px 24px rgba(102, 126, 234, 0.3);
}

/* 装饰光晕 */
.account-user-card::before {
  content: '';
  position: absolute;
  top: -60%;
  right: -20%;
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(255,255,255,0.12) 0%, transparent 70%);
  border-radius: 50%;
  pointer-events: none;
}

.account-user-card::after {
  content: '';
  position: absolute;
  bottom: -40%;
  left: -10%;
  width: 160px;
  height: 160px;
  background: radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%);
  border-radius: 50%;
  pointer-events: none;
}

.account-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
  border: 2px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(4px);
}

.account-avatar-text {
  color: #fff;
  font-size: 26px;
  font-weight: 700;
}

.account-user-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative;
  z-index: 1;
}

.account-user-name {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}

.account-user-device {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  gap: 5px;
}

.account-user-device i {
  font-size: 14px;
}

/* 功能区块 */
.account-section {
  background: #fff;
  border-radius: 16px;
  margin-top: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.account-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  cursor: pointer;
}

.account-section-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.account-section-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #fff;
}

.account-section-left span {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a2e;
}

.account-arrow {
  font-size: 18px;
  color: #bbb;
  transition: transform 0.2s ease;
}

.account-section-body {
  padding: 0 18px 18px;
  border-top: 1px solid #f0f0f0;
  padding-top: 16px;
}

/* 退出按钮 */
.account-logout-btn {
  width: 100%;
  margin-top: 24px;
  padding: 14px;
  border: none;
  border-radius: 14px;
  background: #fff;
  color: #ff4757;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  transition: transform 0.2s ease;
}

.account-logout-btn:active {
  transform: scale(0.97);
}

/* ---- 密码表单样式 ---- */
.account-section-body .cube-form {
  background: transparent;
}

.account-section-body .cube-form .cube-form-label {
  font-size: 13px;
  color: #666;
  padding: 10px 0 4px;
}

.account-section-body .cube-form .cube-input {
  border: none;
  border-radius: 8px;
  background: #f4f6fb;
  padding: 0 12px;
}

.account-section-body .cube-form .cube-input_active {
  box-shadow: none;
}

.account-section-body .cube-form .cube-input-field {
  height: 40px;
  font-size: 14px;
}

.account-section-body .cube-form .cube-btn {
  width: 100%;
  margin-top: 16px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border: none;
  border-radius: 10px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  padding: 12px;
  text-align: center;
  cursor: pointer;
}

.account-section-body .cube-form .cube-btn:active {
  opacity: 0.9;
}

/* 密码小眼睛 */
.account-section-body .cube-input-eye {
  color: #999;
  cursor: pointer;
  transition: color 0.2s ease;
}

.account-section-body .cube-input-eye:hover {
  color: #667eea;
}

.account-section-body .cube-input-eye i {
  font-size: 18px;
}
</style>
